import React from "react";
import Nav from "../Home/Nav/Nav";
import PageTop from "../../common/PageTop/PageTop";
import Footer from "../../common/Footer/Footer";
import About2Content from "./About2Content";
import MailUs from "../MailUs/MailUs";
import about from "../../../assets/images/about.jpg"

const About2Page = () => {
  return (
    <>
      <Nav />
      <PageTop title={"About Us"} image={about}/>
      <About2Content/>
      <MailUs/>
      <Footer />
    </>
  );
};

export default About2Page;
